import Clarity from "@microsoft/clarity";
import { action, computed, makeObservable, observable } from "mobx";
import { persist } from "mobx-persist";
import { AuthApi } from "src/api";
import { Storage } from "src/services";

const emptyUserData = {
  id: 0,
  companyCode: "",
  name: "",
  email: "",
  rememberMeToken: false,
  finishedAdmissionAccess: false,
  configurations: {
    webNotifications: false,
    appNotifications: false,
    emailNotifications: false,
  },
  isFreeTrial: true,
};

export default class AuthStore {
  @persist("object")
  @observable
  userData: User = emptyUserData;

  constructor() {
    makeObservable(this);
  }

  @computed
  get getUserName(): string {
    return this.userData.name;
  }

  @action
  login = async ({ email, password, userId, yappToken }: Credentials): Promise<void> => {
    const credentials = { email, password, userId, yappToken };
    const token = await AuthApi.login(credentials);
    Storage.setToken(token);

    const user = await AuthApi.fetchUser(credentials);
    this.userData = user;
    Storage.setUserName(user.name);
    Storage.setUserId(user.id);
    Storage.setCompanyCode(user.companyCode);
    Storage.setUserEmail(email || user.email);
    Storage.setUserFinishedAdmissionAccess(user.finishedAdmissionAccess);
    Storage.setEncryptedPassword(password);
    Clarity.identify(user.companyCode);
    Clarity.setTag("type", user.isFreeTrial ? "Teste grátis" : "Cliente");
  };

  @action
  logout = (): void => {
    this.userData = emptyUserData;
    Storage.clearWholeStorage();
  };
}
